// extracted by mini-css-extract-plugin
export var banner = "StandardHero-module--banner--jjGra";
export var bannerContent = "StandardHero-module--bannerContent--EhEv7";
export var breadcrumbs = "StandardHero-module--breadcrumbs--meBXh";
export var heading = "StandardHero-module--heading--969J0";